import { LegendContinuous } from './legendContinuous';
import { LegendContinuousSize } from './legendContinuousSize';
export var LegendContinuousBlockSize = function LegendContinuousBlockSize(options) {
  return LegendContinuousSize(Object.assign({}, {
    block: true
  }, options));
};
LegendContinuousBlockSize.props = Object.assign(Object.assign({}, LegendContinuous.props), {
  defaultPosition: 'top',
  defaultOrientation: 'horizontal'
});